// External Modules
import styled from '@emotion/styled';

//Internal modules

import {
  FONT_SIZE_SMALL,
  FONT_WEIGHT_NORMAL_PP,
  LABEL_COLOR,
} from '@/styles/styleVariables';
import { bodyStyles } from '@/styles/fontRebrandingStyles';
import { StyledText } from '@/components/Common';

export const StyledCRSTaxDisclosureText = styled(StyledText)`
  color: ${LABEL_COLOR};
  font-size: ${FONT_SIZE_SMALL};
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
  line-height: 20px;
  text-align: left;

  .overrides-font-4-2 & {
    ${bodyStyles}
  }
`;
